import React, { Component, createElement, Fragment } from 'react';
import { ComponentsManager } from '@comall-backend-builder/core';
import { EntitiesManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { Button } from '@comall-backend-builder/components-basis';
import { Modal as AntModal } from 'antd';

interface ProductSelectorProps {
    componentId: string;
    onSelect: (keys: string[]) => void;
}

interface ProductSelectorStates {
    selectedKeys: string[];
    visible: boolean;
}

export class productSelector extends Component<ProductSelectorProps, ProductSelectorStates> {
    private entity: Entity;

    static defaultProps = {
        onSelect: () => {},
    };

    constructor(props: ProductSelectorProps) {
        super(props);
        this.state = {
            selectedKeys: [],
            visible: false,
        };
        this.entity = new (EntitiesManager.get('product'))({});
        this.entity.params = {
            // 传递过滤参数
            available_stock_status: 'IN_STOCK',
            black_flag: 0,
        };

        this.onShow = this.onShow.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    onShow() {
        this.setState({ visible: true });
    }

    onHide() {
        this.setState({ visible: false });
    }

    onSave() {
        const { selectedKeys } = this.state;
        const { onSelect } = this.props;
        this.onHide();
        onSelect(selectedKeys);
    }

    renderFilter() {
        const { componentId } = this.props;
        const filterProps = {
            entity: this.entity,
            componentId,
            labelCol: 6,
            fields: [
                {
                    property: 'sku',
                },
                {
                    property: 'name',
                },
                {
                    property: 'spu',
                },
                {
                    property: 'style_code',
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
        };
        return createElement(ComponentsManager.get('FilterFormPlus'), filterProps);
    }
    renderTable() {
        const { componentId } = this.props;
        const tableProps = {
            entity: this.entity,
            componentId,
            rowKey: 'sku',
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns: [
                {
                    property: 'sku',
                },
                {
                    property: 'brand',
                },
                {
                    property: 'name',
                },
            ],
            rowSelection: {
                columnTitle: '选择',
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selectedKeys,
                    });
                },
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }
    render() {
        return (
            <Fragment>
                <Button type="primary" onClick={this.onShow}>
                    关联商品
                </Button>
                <AntModal
                    visible={this.state.visible}
                    title="选择商品"
                    okText="添加"
                    cancelText="取消"
                    onCancel={this.onHide}
                    onOk={this.onSave}
                    mask
                    width={1000}
                >
                    {this.renderFilter()}
                    {this.renderTable()}
                </AntModal>
            </Fragment>
        );
    }
}
